export default function isURL(str: string): boolean {
    return str.indexOf("http") !== -1;
}